module.exports = __webpack_public_path__ + "img/drehmoment.50d7fb34.jpg";